module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "autocomplete-group"
    }
  }, [_c('v-autocomplete', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.onClickaway),
      expression: "onClickaway"
    }],
    staticClass: "no-border",
    attrs: {
      "items": _vm.group_options,
      "get-label": _vm.getLabel,
      "component-item": _vm.template,
      "input-attrs": _vm.attrs,
      "auto-select-one-item": false
    },
    on: {
      "update-items": _vm.updateGroups,
      "item-selected": _vm.selected
    },
    model: {
      value: (_vm.group_filter),
      callback: function($$v) {
        _vm.group_filter = $$v
      },
      expression: "group_filter"
    }
  }), _c('span', {
    staticClass: "gray-bold-caret"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ba22aa6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/autocomplete/group.vue
// module id = 1035
// module chunks = 1